// Restyled 1D/1W/1M/1Y pills -- one sliding active background instead of
// independently-toggled buttons.
const TimeframeTabs = ({ options, active, onChange }) => {
  const activeIndex = Math.max(0, options.indexOf(active));

  return (
    <div role="tablist" aria-label="Timeframe" className="relative inline-flex items-center p-0.5 rounded-lg bg-gray-100 dark:bg-white/[0.03] border border-gray-200 dark:border-white/[0.06]">
      <div
        className="absolute top-0.5 bottom-0.5 rounded-md bg-gradient-to-br from-violet-500/25 to-indigo-500/25 transition-transform duration-200 ease-out"
        style={{
          width: `calc(${100 / options.length}% - 2px)`,
          transform: `translateX(${activeIndex * 100}%)`,
          left: 1,
        }}
      />
      {options.map((opt) => (
        <button
          key={opt}
          role="tab"
          type="button"
          aria-selected={opt === active}
          onClick={() => onChange(opt)}
          className={`relative z-10 px-3 py-1.5 text-[12px] font-medium rounded-md transition-colors ${
            opt === active ? 'text-indigo-700 dark:text-indigo-200' : 'text-gray-500 hover:text-gray-800 dark:text-white/40 dark:hover:text-white/70'
          }`}
        >
          {opt}
        </button>
      ))}
    </div>
  );
};

export default TimeframeTabs;
